export default function serviceFiltering() {
    const serviceFilterSelect = document.querySelector('.js-service-filter-select');

    const serviceFilterList = document.querySelector('.js-services-list');
    const debug = true;

    if (serviceFilterSelect && serviceFilterList) {
        const initialItems = Array.from(serviceFilterList.children).map(child => child.cloneNode(true));

        function handleFiltering() {
            const currentCategory = serviceFilterSelect.value;

            const itemsToShow = initialItems.filter(item => {
                if (!item.hasAttribute('data-category')) {
                    return true;
                }
                const itemCategories = item.getAttribute('data-category').split(',');
                if (itemCategories.includes(currentCategory)) {
                    return true;
                } else {
                    return false;
                }
            });

            if (debug) console.log(`Items to show after filtering for category ${currentCategory}`, itemsToShow);

            serviceFilterList.innerHTML = '';

            itemsToShow.forEach(item => {
                serviceFilterList.appendChild(item.cloneNode(true));
            })
        }

        handleFiltering();



        serviceFilterSelect.addEventListener('change', handleFiltering);
    }
}